export type SourceIdValue = string | number | null | undefined;

export function toSourceIdString(value: SourceIdValue): string | null {
  if (value == null) return null;
  const raw = typeof value === 'string' ? value.trim() : String(value);
  return raw.length > 0 ? raw : null;
}

export function sourceIdsEqual(left: SourceIdValue, right: SourceIdValue): boolean {
  const leftText = toSourceIdString(left);
  const rightText = toSourceIdString(right);
  return leftText != null && rightText != null && leftText === rightText;
}

export function sourceIdListIncludes(list: SourceIdValue[] | null | undefined, target: SourceIdValue): boolean {
  const targetText = toSourceIdString(target);
  if (targetText == null || !Array.isArray(list)) return false;
  return list.some((item) => toSourceIdString(item) === targetText);
}
